<div class="contacts-page-container">
    <div class="contacts-page-container-inner">
        <div class="contacts-page-title" [ngClass]="{'highlight': isHighlighted}" #title>
            контакты
        </div>
        <div class="contacts-page-workspace">
            <div class="contacts-page-subtitle">
                Северная железная дорога – филиал ОАО «РЖД»
            </div>
            <div class="contacts-page-borders">
                <div class="col-5 contacts-page-workspace-text">
                    Почта пресс-службы Северной железной дороги
                </div>
                <div class="col-7 contacts-page-workspace-text contacts-page-paddings">
                    <a href="mailto:nrr.press@yandex.ru">{{ 'nrr.press@yandex.ru' }}</a>
                </div>
            </div>
            <div class="contacts-page-borders">
                <div class="col-5 contacts-page-workspace-text">
                    Номера пресс-службы Северной железной дороги
                </div>
                <div class="col-7 contacts-page-workspace-text contacts-page-paddings">
                    <a href="tel:+74852520198 ">+7(4852) 52-01-98</a>, <a href="tel:+74852520199 ">52-01-99</a>
                </div>
            </div>
            <div class="contacts-page-borders">
                <div class="col-5 contacts-page-workspace-text">
                    Сайт Северной железной дороги
                </div>
                <div class="col-7 contacts-page-workspace-text contacts-page-paddings">
                    <a target="_blank" href="https://szd.rzd.ru/">https://szd.rzd.ru/</a>
                </div>
            </div>
            <div class="contacts-page-footer-icons contacts-page-borders">
                <div class="contacts-page-footer-icon">
                    <a target="_blank" href="https://vk.com/szd_official">
                        <app-icon [icon]="Icons.vk"/>
                    </a>
                </div>
                <div class="contacts-page-footer-icon" style="margin-left: 0.7rem">
                    <a target="_blank" href="https://t.me/szdrzd">
                        <app-icon [icon]="Icons.tg"/>
                    </a>
                </div>
            </div>
        </div>
    </div>
</div>
